import React from 'react';
import classNames from 'classnames';
import GeneralImage from './GeneralImage';
import { ImageModel } from '@/types';
import { ResponsiveImageSizesType } from '../general/ResponsiveImage';
import { fadeIn } from '@/animations';

export type ImageElementModel = {
  image?: ImageModel;
  widths: ResponsiveImageSizesType;
  heights: ResponsiveImageSizesType;
} & React.HTMLAttributes<HTMLDivElement>;

const ImageElement = ({ image, className, widths, heights, ...props }: ImageElementModel) => {
  if (!image) {
    return null;
  }

  return (
    <div className={classNames('image-element overflow-hidden', className)} {...props}>
      <GeneralImage
        className="[&_.general-image]:w-full"
        image={image}
        widths={widths}
        heights={heights}
        animation={fadeIn}
      />
    </div>
  );
};

export default ImageElement;
